import React, { useState } from 'react';
import {
  Container,
  BackgroundCircle,
  FormWrapper,
  Title,
  Input,
  TextArea,
  Button,
  PrivacyText,
  PrivacyLink,
  SuccessText
} from './styled';

const ContactForm: React.FC = () => {
  const [sent, setSent] = useState<boolean>(false);
  const [name, setName] = useState<string>();
  const [email, setEmail] = useState<string>();
  const [message, setMessage] = useState<string>();

  const formSubmitHandler = () => {
    fetch("https://formsubmit.co/support@telmamicro.in", {
      method: "POST",
      body: JSON.stringify({
        name,
        email,
        message
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8"
      }
    });
    setSent(true);
    setName('');
    setEmail('');
    setMessage('');
  }
  return (
    <>
    <Title id="contact">
        Contact <span>Us</span>
    </Title>
    <Container>

      {/* Background Circles */}
      <BackgroundCircle className="top-right" />
      <BackgroundCircle className="bottom-left" />

      {/* Form */}
      <FormWrapper>
        <Input type="text" placeholder="Name" name="Name" value={name} onChange={(e) => setName(e.target.value)}/>
        <Input type="email" placeholder="Email" name="email" value={email} onChange={(e) => setEmail(e.target.value)}/>
        <TextArea placeholder="Message" rows={5} name="Message" value={message} onChange={(e) => setMessage(e.target.value)}/>
        {sent && <SuccessText>Thankyou for contacting. We will reach out to you shortly!</SuccessText>}
        <PrivacyText>
          By Submitting you confirm that you agree to our{' '}
          <PrivacyLink href="#">Privacy Statement</PrivacyLink>
        </PrivacyText>
        <Button onClick={formSubmitHandler}>Get In Touch</Button>
      </FormWrapper>
    </Container>
    </>
  );
};

export default ContactForm;
